import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { logging } from '../../../actions/log';
import styles from './Button.module.less';
import { setIframeVisible } from '../../../actions/layout';
import { gameCDKSetVisible } from '../../../actions/gamecdk';
import { emptyLoginClose } from '../../../actions/user';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);
const selectLoginClose = createSelector(
  state => state.user,
  user => user.loginBoxClose,
);

export default memo(
  ({
    soft,
    info = {},
    logInfo = {},
    reductionTag = () => {},
    clickCallbackTag = false,
    hoverTag = false,
  }) => {
    let btnClassName = styles.sbutton_open;
    const dispatch = useDispatch();
    const logInfoData = useSelector(selectLogInfo);
    const userInfo = useSelector(selectUserInfo);
    const loginBoxClose = useSelector(selectLoginClose);
    const [isClickBtn, setIsClickBtn] = useState(false);

    useEffect(() => {
      if (clickCallbackTag) {
        handleBuySoft(soft, logInfo);
        reductionTag();
      }
    }, [clickCallbackTag]);
    useEffect(() => {
      return () => {
        setIsClickBtn(false);
        dispatch(emptyLoginClose());
      };
    }, []);

    useEffect(() => {
      if (isClickBtn && loginBoxClose?.result === 0) {
        setIsClickBtn(false);
        dispatch(emptyLoginClose());
      }
    }, [loginBoxClose, isClickBtn]);

    useEffect(() => {
      if (userInfo && userInfo?.st && isClickBtn) {
        try {
          let softInfo = soft?.extInfo?.appInfo || null;
          if (softInfo && softInfo?.sourceInfo && soft?.extInfo?.sourceType === 2) {
            let gameCdkPrice = 0;
            let gameCdkSid = 0;
            let priceStr =
              softInfo?.sourceInfo?.sellInfo?.currentPrice ||
              softInfo?.sourceInfo?.sellInfo?.originalPrice;
            gameCdkPrice = parseFloat(priceStr.replace('¥', '').replace('￥', ''));
            gameCdkSid = softInfo?.sourceInfo?.sku?.sid;
            setIsClickBtn(false);
            setTimeout(() => {
              dispatch(
                gameCDKSetVisible({
                  isShow: true,
                  soft: { ...soft, gameCdkPrice, gameCdkSid },
                  source: logInfo.source || logInfoData.source,
                }),
              );
            }, 10);
          }
        } catch (error) {}
        setIsClickBtn(false);
      }
    }, [soft, isClickBtn, userInfo]);

    useEffect(() => {
      if (isClickBtn && loginBoxClose?.result === 0) {
        setIsClickBtn(false);
        dispatch(emptyLoginClose());
      }
    }, [loginBoxClose, isClickBtn]);
    useEffect(() => {
      if (userInfo && userInfo?.st && isClickBtn) {
        try {
          let softInfo = soft?.extInfo?.appInfo || null;
          if (softInfo && softInfo?.sourceInfo && soft?.extInfo?.sourceType === 2) {
            let gameCdkPrice = 0;
            let gameCdkSid = 0;
            let priceStr =
              softInfo?.sourceInfo?.sellInfo?.currentPrice ||
              softInfo?.sourceInfo?.sellInfo?.originalPrice;
            gameCdkPrice = parseFloat(priceStr.replace('¥', '').replace('￥', ''));
            gameCdkSid = softInfo?.sourceInfo?.sku?.sid;
            setIsClickBtn(false);
            setTimeout(() => {
              dispatch(
                gameCDKSetVisible({
                  isShow: true,
                  soft: { ...soft, gameCdkPrice, gameCdkSid },
                  source: logInfo.source || logInfoData.source,
                }),
              );
            }, 10);
          }
        } catch (error) {}
        setIsClickBtn(false);
      }
    }, [soft, isClickBtn, userInfo]);

    const handleBuySoft = useCallback(
      (soft_info, logInfo_para) => {
        if (soft_info?.extInfo?.appInfo?.sourceInfo) {
          const logParam2 = {
            source: logInfo_para.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid:
              soft_info?.extInfo?.appInfo.softID ||
              soft_info?.extInfo?.appInfo.softId ||
              soft_info?.extInfo?.appInfo.SoftID,
            softName: soft_info?.extInfo?.appInfo.softName,
            softType: '10',
            type:
              soft?.extInfo?.appInfo?.sourceInfo &&
              soft?.extInfo?.appInfo?.sourceInfo.sellInfo &&
              soft?.extInfo?.appInfo?.sourceInfo.sellInfo.originalPrice
                ? 'b'
                : 'o', // 购买还是打开
            sourceUrl: soft_info?.extInfo?.appInfo?.sourceInfo.sourceUrl,
            sourceInfo: soft_info?.extInfo?.appInfo?.sourceInfo,
          };

          // 按钮点击打桩
          dispatch(
            logging({
              category: 'C',
              action: 'Install',
              label: '',
              param2: {
                ...logParam2,
                softType:
                  soft_info?.extInfo?.appInfo?.sourceInfo?.sourceType === 1 ||
                  soft_info?.extInfo?.appInfo?.sourceInfo?.sourceType === 2
                    ? '11'
                    : '10',
              },
              param3: soft_info?.bizInfo || null,
            }),
          );
          if (soft_info?.extInfo?.sourceType === 1) {
            dispatch(
              gameCDKSetVisible({
                isShow: true,
                soft: { ...soft_info?.extInfo?.appInfo, gameCdkPrice, gameCdkSid },
                source: logInfo.source || logInfoData.source,
              }),
            );
          } else if (soft_info?.extInfo?.sourceType === 2) {
            if (userInfo && userInfo?.st) {
              let gameCdkPrice = 0;
              let gameCdkSid = 0;
              try {
                let priceStr = soft_info?.currentPrice || soft_info?.originalPrice;
                gameCdkPrice = parseFloat(priceStr.replace('¥', '').replace('￥', ''));
                gameCdkSid = soft_info?.extInfo?.sid;
              } catch (error) {}
              dispatch(
                gameCDKSetVisible({
                  isShow: true,
                  soft: { ...soft_info?.extInfo?.appInfo, gameCdkPrice, gameCdkSid },
                  source: logInfo.source || logInfoData.source,
                }),
              );
            } else {
              setIsClickBtn(true);

              window.CallNativeMethod('logout');
              window.CallNativeMethod('login');
            }
          } else {
            window.open(soft_info?.extInfo?.appInfo?.sourceInfo?.sourceUrl);
          }
        }
      },
      [dispatch, logInfoData, userInfo],
    );

    // 处理第三方的软件

    return (
      <div
        className={`${btnClassName} ${info?.className} ${hoverTag ? styles.btn_hover : ''} `}
        onClick={e => {
          e.preventDefault();
          handleBuySoft(soft, logInfo);
        }}
      >
        立即购买
        <span className={`${styles.triangle} ${info?.tagClass}`} />
      </div>
    );
  },
);
